<template>
  <v-chip
    :color="poStatusColor"
    class="text-uppercase white--text user-select-none"
    :small="small"
  >{{ poStatusType.value }}</v-chip>
</template>

<script>
import colors from 'vuetify/lib/util/colors';
import PurchaseOrderLineStatus from '@/models/purchaseOrderLineStatus';

export default {
  name: 'PoLineItemStatus',
  data: () => ({
  }),
  props: {
    poStatus: String,
    small: Boolean,
  },
  computed: {
    poStatusType() {
      return PurchaseOrderLineStatus.get(this.poStatus);
    },
    poStatusColor() {
      switch (this.poStatusType.key) {
        case PurchaseOrderLineStatus.NotSubmitted.key:
          return colors.blueGrey.base;
        case PurchaseOrderLineStatus.ImagesUploaded.key:
          return colors.yellow.darken2;
        case PurchaseOrderLineStatus.UnderReview.key:
          return colors.lightBlue.lighten2;
        case PurchaseOrderLineStatus.NotApproved.key:
          return colors.red.darken2;
        case PurchaseOrderLineStatus.Approved.key:
          return colors.green.darken1;
        default:
          return colors.grey.lighten2;
      }
    },
  },
};
</script>
